
import { useEffect, useState } from 'react';

import { Box, Button, Card, CardContent, CardHeader, Chip, CircularProgress, Dialog, DialogActions, DialogContent, DialogTitle, Divider, FormControl, FormControlLabel, FormLabel, Grid, IconButton, InputLabel, MenuItem, Paper, Radio, RadioGroup, Select, Stack, Table, TableBody, TableCell, TableContainer, TableFooter, TableHead, TablePagination, TableRow, TextField, Typography } from '@mui/material';

import ForwardToInboxIcon from '@mui/icons-material/ForwardToInbox';
import CloseIcon from '@mui/icons-material/Close';
import FullscreenIcon from '@mui/icons-material/Fullscreen';
import FullscreenExitIcon from '@mui/icons-material/FullscreenExit';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';

import moment from 'moment';

import { usePages } from '../../hooks/usePages';

import { TablePaginationActions } from '../../helpers/TablePaginationActions';

import { Layout } from "../../components/Layout"

import { DownloadFile } from '../../helpers/DownloadFile';

import { TablePaddingStyle, TableTheadStyle } from '../../styles/TableStyle';

import { ObtenerMateria } from '../../connections/catalogos/MateriaConnection';
import { ObtenerTipoTramites } from '../../connections/catalogos/TipoTramiteConnection';
import { ConsultaTramitesRecibidos, DescargarTramitesRecibidos } from '../../connections/comun/RecepcionConnection';

import { AnexoProps } from '../../interfaces/comun/AnexoInterface';
import { MateriaProps } from '../../interfaces/catalogos/MateriaInterface';
import { TipoTramiteProps } from '../../interfaces/catalogos/TipoTramiteInterface';
import { ConsultaTramitesRecibidosProps } from '../../interfaces/comun/RecepcionInterface';

type EnvioBuzonType = 'Todos' | 'Si' | 'No';

export const TramitesRecibidosPage = () => {

    const [recordsCount, setRecordsCount] = useState(0);

    const [fecha, setFecha] = useState('');

    const [rows, setRows] = useState<ConsultaTramitesRecibidosProps[]>([]);

    const [tipoTramite, setTipoTramite] = useState(0);
    const [tipoTramiteArray, setTipoTramiteArray] = useState<TipoTramiteProps[]>([]);

    const [openAnexos, setOpenAnexos] = useState(false);
    const [anexos, setAnexos] = useState<AnexoProps[]>([]);

    const [filtroAplicado, setFiltroAplicado] = useState(false);

    const [loading, setLoading] = useState(false);
    const [loadingSearch, setLoadingSearch] = useState(false);
    const [loadingDescargar, setLoadingDescargar] = useState(false);

    const [openAcuse, setOpenAcuse] = useState(false);
    const [documento, setDocumento] = useState('');
    const [fullScreen, setFullScreen] = useState(false);

    const [materia, setMateria] = useState(0);
    const [materiaArray, setMateriaArray] = useState<MateriaProps[]>( [] );

    const [envioBuzon, setEnvioBuzon] = useState<EnvioBuzonType>( 'Todos' );

    const { page, rowsPerPage, handleChangePage, handleChangeRowsPerPage, resetPage } = usePages();
    const { page: pageAnexos, rowsPerPage: rowsPerPageAnexos, handleChangePage: handleChangePageAnexos, handleChangeRowsPerPage: handleChangeRowsPerPageAnexos } = usePages();

    const handleClearFiltro = () => {

        setFiltroAplicado(false);

        setFecha('');
        setTipoTramite(0);

        setRows([]);
        setRecordsCount(0);

        resetPage();

    }

    const handleBuscarTramites = async () => {

        setLoadingSearch(true);
        setFiltroAplicado(true);

        resetPage();
        setRecordsCount(0);
    }

    const handleDescargar = async () => {

        setLoadingDescargar(true);

        const porBuzon = envioBuzon === 'Todos' ? 0 : envioBuzon === 'Si' ? 1 : 2;

        await DescargarTramitesRecibidos({ idTipoTramite: tipoTramite, fecha: fecha, idMateria: materia, enviadoBuzon: porBuzon }).then(resp => {

            if (resp) {

                setTimeout(() => {

                    DownloadFile(`Trámites Recibidos-${Date.now()}.xlsx`, resp);

                    setLoadingDescargar(false);

                }, 700);

            }

        });

    }

    useEffect(() => {

        async function Obtener() {

            await ObtenerTipoTramites().then(resp => {
                setTipoTramiteArray(resp);
            });

        }

        Obtener();

    }, []);

    useEffect(() => {

        async function Obtener() {

            await ObtenerMateria().then( resp => {

                setMateriaArray( resp );

            });

        }

        Obtener();

    }, []);

    useEffect(() => {

        async function Obtener() {

            setLoading(true);
            setRows([]);

            await ConsultaTramitesRecibidos({ page, rowsPerPage, idTipoTramite: 0, fecha: '', enviadoBuzon: 0, idMateria: 0 }).then(resp => {

                const { recordsCount, records } = resp;

                setTimeout(() => {

                    setRecordsCount(recordsCount);
                    setRows(records);
                    setLoadingSearch(false);
                    setLoading(false);

                }, 700);

            });

        }

        if (!filtroAplicado) {
            Obtener();
        }

    }, [page, rowsPerPage, filtroAplicado]);

    useEffect(() => {

        async function Obtener() {

            setLoading(true);
            setRows([]);
            
            const porBuzon = envioBuzon === 'Todos' ? 0 : envioBuzon === 'Si' ? 1 : 2;

            await ConsultaTramitesRecibidos({ page, rowsPerPage, idTipoTramite: tipoTramite, fecha, enviadoBuzon: porBuzon, idMateria: materia }).then(resp => {

                const { recordsCount, records } = resp;

                setTimeout(() => {

                    setRecordsCount(recordsCount);
                    setRows(records);
                    setLoadingSearch(false);
                    setLoading(false);

                }, 700);

            });

        }

        if ( filtroAplicado ) {
            Obtener();
        }

    }, [ page, rowsPerPage, filtroAplicado, tipoTramite, fecha, materia, envioBuzon ]);

    useEffect(() => {

        if ( openAcuse ) {
            setFullScreen(false);
        }

    }, [ openAcuse ])

    return (
        <Layout breadcrumbs={[{ text: 'Consultas' }, { text: 'Trámites recibidos' }]} backgroundPaper={false}>

            <Grid container spacing={3} >

                <Grid size={{ md: 12, xs: 12 }}>

                    <Card>

                        <CardHeader
                            sx={{ backgroundColor: (theme) => theme.palette.primary.main }}
                            subheader={<Typography sx={{ fontWeight: '400', color: 'white' }}> Filtro(s) </Typography>}
                        />

                        <Divider />

                        <CardContent sx={{ p: 3 }}>

                            <Grid container spacing={3}>

                                <Grid size={{ md: 4, xs: 12 }}>

                                    <TextField
                                        fullWidth
                                        label="Fecha del trámite"
                                        type="date"
                                        name="fechaTramite"
                                        value={fecha}
                                        onChange={(e) => setFecha(e.target.value)}
                                        disabled={filtroAplicado}
                                        slotProps={{
                                            input: {
                                                autoComplete: 'off'
                                            },
                                            inputLabel: {
                                                shrink: true,
                                            }
                                        }}
                                    />

                                </Grid>

                                <Grid size={{ md: 4, xs: 12 }}>

                                    <FormControl fullWidth>

                                        <InputLabel id="select-tipoTramite-label">Tipo de trámite</InputLabel>

                                        <Select
                                            labelId="select-tipoTramite-label"
                                            label="Tipo de trámite"
                                            value={tipoTramite}
                                            onChange={(e) => setTipoTramite(parseInt(e.target.value.toString() ?? '0'))}
                                            disabled={filtroAplicado}
                                        >
                                            <MenuItem value={0}>Selecciona una opción</MenuItem>
                                            {
                                                tipoTramiteArray.map(({ idTipoTramite, descripcion }) => (
                                                    <MenuItem key={idTipoTramite} value={idTipoTramite}>{descripcion}</MenuItem>
                                                ))
                                            }
                                        </Select>

                                    </FormControl>

                                </Grid>

                                <Grid size={{ md: 4, xs: 12 }}>
                                
                                    <FormControl fullWidth>

                                        <InputLabel>Materia</InputLabel>

                                        <Select
                                            label='Materia'
                                            disabled={ filtroAplicado }
                                            value={ materia }
                                            onChange={ (e) => setMateria( e.target.value ) }
                                        >
                                            <MenuItem key={0} value={0}>Selecciona una opción</MenuItem>
                                            {
                                                materiaArray
                                                .map(({ idMateria, descripcion }) => (
                                                    <MenuItem key={idMateria} value={idMateria}>{ descripcion }</MenuItem>
                                                ))
                                            }
                                        </Select>

                                    </FormControl>

                                </Grid>

                                <Grid size={{ md: 9, xs: 12 }}>

                                    <FormControl>

                                        <FormLabel>Mostrar trámites enviados por buzón electrónico</FormLabel>

                                        <RadioGroup row >

                                            <FormControlLabel
                                                disabled={ filtroAplicado }
                                                label={ 'Todos' }
                                                control={ <Radio checked={ envioBuzon === 'Todos' } onChange={ () => setEnvioBuzon( 'Todos' ) } />}
                                            />

                                            <FormControlLabel
                                                disabled={ filtroAplicado }
                                                label={ 'Si' }
                                                control={ <Radio checked={ envioBuzon === 'Si' } onChange={ () => setEnvioBuzon( 'Si' ) } />}
                                            />
                                    
                                            <FormControlLabel
                                                disabled={ filtroAplicado }
                                                label={ 'No' }
                                                control={ <Radio checked={ envioBuzon === 'No' } onChange={ () => setEnvioBuzon( 'No' ) } />}
                                            />

                                        </RadioGroup>

                                    </FormControl>

                                </Grid>

                                <Grid size={{ md: 3, xs: 12 }}>

                                    <Button
                                        fullWidth
                                        variant={ 'contained' }
                                        color={ filtroAplicado ? 'inherit' : 'primary' }
                                        loading={ loadingSearch}                                      
                                        onClick={ () => { filtroAplicado ? handleClearFiltro() : handleBuscarTramites() } }
                                    >
                                        { filtroAplicado ? 'limpiar filtro' : 'Buscar' }
                                    </Button>

                                </Grid>

                            </Grid>

                        </CardContent>

                    </Card>

                </Grid>

                <Grid size={{ md: 12, xs: 12 }} textAlign={'right'}>

                    <Button
                        color='secondary'
                        variant="outlined"
                        sx={{ mt: 1 }}
                        loading={loadingDescargar}
                        disabled={rows.length === 0}
                        onClick={handleDescargar}
                    >
                        Descargar información
                    </Button>

                </Grid>

                <Grid size={{ md: 12, xs: 12 }}>

                    <TableContainer sx={{ borderRadius: 3 }} component={Paper}>

                        <Table sx={{ minWidth: 500 }}>

                            <TableHead sx={{ ...TableTheadStyle }}>

                                <TableRow sx={{ borderTopLeftRadius: 10, borderTopRightRadius: 10 }}>

                                    <TableCell style={{ ...TablePaddingStyle, ...TableTheadStyle, width: '10%', fontWeight: 'bold' }}></TableCell>
                                    <TableCell style={{ ...TablePaddingStyle, ...TableTheadStyle, width: '15%', fontWeight: 'bold', textAlign: 'center' }}>Referencia</TableCell>
                                    <TableCell style={{ ...TablePaddingStyle, ...TableTheadStyle, width: '15%', fontWeight: 'bold' }}>Tipo de trámite</TableCell>
                                    <TableCell style={{ ...TablePaddingStyle, ...TableTheadStyle, width: '10%', fontWeight: 'bold', textAlign: 'center' }}>Anexo(s)</TableCell>
                                    <TableCell style={{ ...TablePaddingStyle, ...TableTheadStyle, width: '10%', fontWeight: 'bold', textAlign: 'center' }}>Acuse</TableCell>
                                    <TableCell style={{ ...TablePaddingStyle, ...TableTheadStyle, width: '10%', fontWeight: 'bold', textAlign: 'center' }}>Estatus</TableCell>
                                    <TableCell style={{ ...TablePaddingStyle, ...TableTheadStyle, width: '20%', fontWeight: 'bold' }}></TableCell>

                                </TableRow>

                            </TableHead>

                            <TableBody>

                                {
                                    rows
                                        .map(({ entregado, numeroSeguimiento, idListadoEntrega, fecha, referencia, materia, noReferencia, tipoTramite, subTipoTramite, anexos, usuarioAsignado, estatus, idEstatus, folioBuzonElectronico, acuse }, index) => (

                                            <TableRow key={index} >

                                                <TableCell>

                                                    <Stack direction="row" alignItems="center" spacing={1}>

                                                        <Typography variant='subtitle1'>
                                                            <strong>{ numeroSeguimiento }</strong>
                                                        </Typography>

                                                        {
                                                            entregado 
                                                            && 
                                                                <Box
                                                                    sx={{
                                                                        display: 'flex',
                                                                        alignItems: 'center',
                                                                        justifyContent: 'center',
                                                                        backgroundColor: '#e8f5e9', 
                                                                        color: '#2e7d32',           
                                                                        borderRadius: '50%',
                                                                        width: 24,                  
                                                                        height: 24,
                                                                    }}
                                                                >
                                                                    <CheckCircleIcon sx={{ fontSize: 16 }} />
                                                                </Box>                                                        
                                                        }

                                                    </Stack>
                                                
                                                    {
                                                        fecha 
                                                        && 
                                                            <Typography variant='subtitle1' fontSize={14}>
                                                                { moment( fecha ).format('DD-MM-YYYY a') }
                                                            </Typography>                                                    
                                                    }

                                                    { 
                                                        ( entregado && idListadoEntrega !== 0 ) 
                                                        && 
                                                            <Typography
                                                                variant="caption"
                                                                sx={{
                                                                    display: 'block',
                                                                    color: 'text.secondary',
                                                                    fontWeight: 500,
                                                                    mt: 0.5 
                                                                }}
                                                            >
                                                                GLE-{idListadoEntrega}
                                                            </Typography>                                                        
                                                    }
                                                </TableCell>

                                                <TableCell sx={{ textAlign: 'center' }}>

                                                    {
                                                        ( noReferencia && referencia )
                                                        ?
                                                            <>
                                                                <Typography variant='subtitle1'><strong>{referencia}</strong></Typography>
                                                                <Typography variant='subtitle2' fontWeight={'normal'} mt={1}>{noReferencia}</Typography>

                                                                <Typography variant='subtitle2' fontWeight={'normal'} mt={1}>({materia})</Typography>
                                                            </>
                                                        :
                                                            <>
                                                                <Typography variant='subtitle1'><strong>{referencia}</strong></Typography>

                                                                {
                                                                    referencia && <Typography variant='subtitle2' fontWeight={'normal'} mt={1}>({materia})</Typography>
                                                                }

                                                            </>
                                                    }

                                                </TableCell>

                                                <TableCell>

                                                    <Typography variant='subtitle1'>
                                                        <strong>{ tipoTramite }</strong>
                                                    </Typography>

                                                    {
                                                        subTipoTramite && <Typography variant='subtitle1' fontSize={14}>{ subTipoTramite } </Typography>
                                                    }

                                                </TableCell>

                                                <TableCell sx={{ textAlign: 'center' }} >

                                                    {
                                                        anexos.length !== 0
                                                        &&
                                                            <Button
                                                                fullWidth
                                                                variant='contained'
                                                                sx={{ textTransform: 'none' }}
                                                                onClick={() => {
                                                                    setAnexos(anexos);
                                                                    setOpenAnexos(true);
                                                                }}
                                                            >
                                                                {anexos.length} anexo(s)
                                                            </Button>
                                                    }

                                                </TableCell>

                                                <TableCell sx={{ textAlign: 'center' }} >

                                                    {
                                                        acuse
                                                        &&
                                                            <Button
                                                                fullWidth
                                                                variant='contained'
                                                                sx={{ textTransform: 'none' }}
                                                                onClick={() => {
                                                                    setDocumento(acuse);
                                                                    setOpenAcuse(true);
                                                                }}
                                                            >
                                                                Ver acuse
                                                            </Button>
                                                    }

                                                </TableCell>

                                                <TableCell sx={{ textAlign: 'center' }}>

                                                    <Chip
                                                        variant='filled'
                                                        sx={{ fontWeight: 'bold' }}
                                                        color={ idEstatus === 9 ? 'primary' : idEstatus === 10 ? 'warning' : 'default' }
                                                        label={
                                                            <Typography variant='subtitle1' fontWeight={'600'} fontSize={14}>
                                                                { estatus }
                                                            </Typography>
                                                        }
                                                    />

                                                </TableCell>

                                                <TableCell>

                                                    {
                                                        usuarioAsignado
                                                        &&
                                                            <>
                                                                <Typography variant='subtitle1'>
                                                                    <strong>Asignado a:</strong>
                                                                </Typography>
                                                                <Typography variant='subtitle2' fontWeight={'normal'} fontSize={14}>{ usuarioAsignado }</Typography>
                                                            </>
                                                    }

                                                    {
                                                        folioBuzonElectronico
                                                        &&
                                                            <Chip
                                                                variant='outlined'
                                                                color="secondary"
                                                                sx={{ p: 2, mt: 1 }}
                                                                icon={<ForwardToInboxIcon fontSize="small" />}
                                                                label={
                                                                    <Typography variant="button" fontWeight={'600'} sx={{ ml: 1 }}>
                                                                        {folioBuzonElectronico}
                                                                    </Typography>
                                                                }
                                                            />
                                                    }

                                                </TableCell>

                                            </TableRow>

                                        ))
                                }

                                {
                                    (rows.length === 0 && !loading)
                                        ?
                                        <TableRow style={{ height: 100 }}>

                                            <TableCell colSpan={7} align="center">

                                                <Typography variant="caption" color='secondary'> No se encontraron resultados </Typography>

                                            </TableCell>

                                        </TableRow>
                                        :
                                        loading
                                        &&
                                        <TableRow style={{ height: 100 }}>

                                            <TableCell colSpan={7} align="center">

                                                <CircularProgress size={26} />

                                            </TableCell>

                                        </TableRow>
                                }

                            </TableBody>

                            <TableFooter>

                                <TableRow>

                                    <TableCell colSpan={2}>
                                        <Typography variant='body2' color='black' sx={{ fontWeight: 'bold' }}> Total de trámites: {recordsCount} </Typography>
                                    </TableCell>

                                    <TablePagination
                                        rowsPerPageOptions={[5, 10, 15, 20, 50, 100]}
                                        colSpan={10}
                                        count={recordsCount}
                                        rowsPerPage={rowsPerPage}
                                        page={page}
                                        onPageChange={handleChangePage}
                                        onRowsPerPageChange={handleChangeRowsPerPage}
                                        ActionsComponent={TablePaginationActions}

                                        labelRowsPerPage="Filas por página"
                                        labelDisplayedRows={
                                            ({ from, to, count }) => {
                                                return '' + from + '-' + to + ' de ' + count
                                            }
                                        }
                                    />

                                </TableRow>

                            </TableFooter>

                        </Table>

                    </TableContainer>

                </Grid>

            </Grid>

            <Dialog open={openAnexos} onClose={() => { }} fullWidth={true} maxWidth="md" >

                <DialogTitle>Anexo(s)</DialogTitle>

                <DialogContent>

                    <TableContainer sx={{ borderRadius: 3 }}>

                        <Table sx={{ minWidth: 500 }}>

                            <TableHead sx={{ ...TableTheadStyle }}>

                                <TableRow sx={{ borderTopLeftRadius: 10, borderTopRightRadius: 10 }}>

                                    <TableCell style={{ ...TablePaddingStyle, ...TableTheadStyle, width: '25%', fontWeight: 'bold' }}>Tipo de anexo</TableCell>
                                    <TableCell style={{ ...TablePaddingStyle, ...TableTheadStyle, width: '25%', fontWeight: 'bold' }}>Tipo de formato</TableCell>
                                    <TableCell style={{ ...TablePaddingStyle, ...TableTheadStyle, width: '10%', fontWeight: 'bold', textAlign: 'center' }}>Cantidad</TableCell>
                                    <TableCell style={{ ...TablePaddingStyle, ...TableTheadStyle, width: '20%', fontWeight: 'bold', textAlign: 'center' }}>Número de fojas</TableCell>
                                    <TableCell style={{ ...TablePaddingStyle, ...TableTheadStyle, width: '20%', fontWeight: 'bold' }}>Observaciones</TableCell>

                                </TableRow>

                            </TableHead>

                            <TableBody>

                                {
                                    (
                                        rowsPerPageAnexos > 0
                                            ?
                                            anexos.slice(pageAnexos * rowsPerPageAnexos, pageAnexos * rowsPerPageAnexos + rowsPerPageAnexos)
                                            :
                                            anexos
                                    ).map(({ tipoAnexo, tipoFormato, cantidad, numeroFojas, observaciones }, index) => (

                                        <TableRow key={index} >

                                            <TableCell> {tipoAnexo} </TableCell>
                                            <TableCell> {tipoFormato} </TableCell>
                                            <TableCell sx={{ textAlign: 'center' }} > {cantidad} </TableCell>
                                            <TableCell sx={{ textAlign: 'center' }}> {numeroFojas} </TableCell>
                                            <TableCell> {observaciones} </TableCell>

                                        </TableRow>

                                    ))
                                }

                                {
                                    anexos.length === 0 &&
                                    (
                                        <TableRow>
                                            <TableCell
                                                colSpan={5}
                                                align="center"
                                                style={{ fontWeight: 'bold', fontSize: 15 }}
                                            >
                                                No se encontraron anexos
                                            </TableCell>
                                        </TableRow>
                                    )
                                }

                            </TableBody>

                            <TableFooter>

                                <TableRow>
                                    <TablePagination
                                        colSpan={5}
                                        rowsPerPageOptions={[5, 10, 15, 20]}
                                        count={anexos.length}
                                        rowsPerPage={rowsPerPageAnexos}
                                        page={pageAnexos}
                                        onPageChange={handleChangePageAnexos}
                                        onRowsPerPageChange={handleChangeRowsPerPageAnexos}

                                        ActionsComponent={TablePaginationActions}

                                        labelRowsPerPage="Filas por página"
                                        labelDisplayedRows={
                                            ({ from, to, count }) => {
                                                return '' + from + '-' + to + ' de ' + count
                                            }
                                        }
                                    />
                                </TableRow>

                            </TableFooter>
                        </Table>

                    </TableContainer>

                </DialogContent>

                <DialogActions>

                    <Button color="secondary" onClick={() => { setOpenAnexos(false); setAnexos([]); }}>
                        Cancelar
                    </Button>

                </DialogActions>

            </Dialog>

            <Dialog
                maxWidth="md"
                fullWidth={true}
                open={openAcuse}
                fullScreen={fullScreen}
                onClose={() => { }}
            >

                <DialogTitle sx={{ backgroundColor: '#3c3c3c', p: 0, textAlign: 'end' }}>

                    <IconButton size='small' sx={{ color: 'white' }} onClick={() => setFullScreen((prev) => !prev)}>
                        {fullScreen ? <FullscreenExitIcon /> : <FullscreenIcon />}
                    </IconButton>

                    <IconButton size='small' sx={{ color: 'white' }} onClick={() => setOpenAcuse(false)}>
                        <CloseIcon />
                    </IconButton>

                </DialogTitle>

                <DialogContent sx={{ p: 0 }}>

                    <Grid container spacing={3} height={'100%'} >

                        <Grid size={{ md: 12, xs: 12 }} sx={{ display: 'flex', alignContent: 'center', justifyContent: 'center' }}>

                            {
                                documento
                                    ?
                                    <iframe title='acuse' src={documento} height={fullScreen ? "100%" : '500px'} width="100%" style={{ border: 'none' }}></iframe>
                                    :
                                    <Typography variant='subtitle2' sx={{ fontSize: 18, fontWeight: 'bold', mt: 10, mb: 10 }}>
                                        No se encontró el acuse de recibo
                                    </Typography>
                            }

                        </Grid>

                    </Grid>

                </DialogContent>

            </Dialog>

        </Layout>
    )
}
